import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { ButtonPrimitive } from '../button-primitive/button-primitive.js';
import { LoadingSpinner } from '../loading-spinner/loading-spinner.js';
import { useString } from '../settings/settings.strings.js';
import { link } from '../link/link.css.js';
import { srOnly } from '../styles/composables.css.js';
import * as button_module from './button.module.css.js';
import { buttonContainer, buttonText, buttonContent, spinnerContainer, spinnerContent, loadingText, button, loading, icon, shortcut } from './button.module.css.js';

const _Button = forwardRef(({ children, variant = 'primary', size = 'md', width = 'hug', iconPrefix, loading: loading$1 = false, disabled, ...props }, ref) => {
    const loadingString = useString('loading');
    return (jsxs(ButtonPrimitive, { "data-fpl-component": "", className: clsx(button, button_module[variant], button_module[size], button_module[width], loading$1 && loading), ...props, ref: ref, disabled: disabled || !!loading$1, children: [jsx("span", { className: buttonContainer, children: jsxs("span", { className: buttonText, children: [iconPrefix && jsx(Icon, { children: iconPrefix }), jsx("span", { className: buttonContent, children: children })] }) }), loading$1 && (jsx("span", { className: spinnerContainer, children: jsxs("span", { className: spinnerContent, children: [jsx(LoadingSpinner, { size: size.includes('large') ? 'md' : 'sm' }), typeof loading$1 !== 'boolean' ? (jsx("span", { className: loadingText, children: loading$1 })) : (jsx("span", { className: srOnly, children: loadingString }))] }) }))] }));
});
_Button.displayName = 'Button';
function Icon({ children }) {
    return (jsx("span", { "aria-hidden": true, className: icon, children: children }));
}
Icon.displayName = 'Button.Icon';
function Shortcut(props) {
    return jsx("span", { "data-fpl-component": "", className: shortcut, ...props });
}
Shortcut.displayName = 'Button.Shortcut';
/**
 * A button that uses the same styles as Link
 */
const Link = forwardRef(function ({ className, ...props }, ref) {
    return (jsx(ButtonPrimitive, { "data-fpl-component": "", ref: ref, className: clsx(link, className), ...props }));
});
Link.displayName = 'Button.Link';
/**
 * FPL's default button, sized to fit content.
 * @see https://fpl.figma.design/components/buttons/button/
 */
const Button = Object.assign(_Button, {
    Icon,
    Shortcut,
    /** A button that uses the same styles as Link */
    Link,
});

export { Button };
//# sourceMappingURL=button.js.map
